@file:OptIn(InternalResourceApi::class)

package eu.codlab.blipya.common_sub_login.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DensityQualifier
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/eu.codlab.blipya.common_sub_login.generated.resources/"

internal val Res.drawable.login_background: DrawableResource by lazy {
      DrawableResource("drawable:login_background", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/login_background.jpg", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("login_background", Res.drawable.login_background)
}
